import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonLoading } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { CreateInventoryRoomModal } from './Modal_CreateInventoryRoom';

import '../../../css/layout.css';

import { CreateInventoryItemModal } from './Modal_CreateInventoryItem';

export function Tab_Management_Inventory () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [createInventoryRoomModal, setCreateInventoryRoomModal] = useState(false);
    let [stockInventoryRoomModal, setStockInventoryRoomModal] = useState(false);
    let [deleteInventoryRoomModal, setDeleteInventoryRoomModal] = useState(false);
    let [adminPasswordCreateInventoryRoomModal, setAdminPasswordCreateInventoryRoomModal] = useState(false);

    let [createInventoryItemModal, setCreateInventoryItemModal] = useState(false);
    let [stockInventoryItemModal, setStockInventoryItemModal] = useState(false);
    let [deleteInventoryItemModal, setDeleteInventoryItemModal] = useState(false);
    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);
    let [adminPasswordDeleteItemModal, setAdminPasswordDeleteItemModal] = useState(false);

    let [selectedFile, seteSlectedFile] = useState(null);

    let [viewRoomDetailsData, setViewRoomDetailsData] = useState([]);
    let [viewRoomItemsDetailsData, setViewRoomItemsDetailsData] = useState([]);

    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);

    let [quantityAddedToRoom, setQuantityAddedToRoom] = useState(null);
    let [quantityReplenishedStock, setQuantityReplenishedStock] = useState(null);

    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);

    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [roomDateCreated, setRoomDateCreated] = useState(null);
    let [roomPic1, setRoomPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic2, setRoomPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic3, setRoomPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic4, setRoomPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [inventory_roomsTab_data, setInventory_roomsTab_data] = useState('true');
    let [inventory_itemsTab_data, setInventory_itemsTab_data] = useState('false');

    let [inventory_roomsTab_view, setInventory_roomsTab_view] = useState('outline')
    let [inventory_itemsTab_view, setInventory_itemsTab_view] = useState('clear')

    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [createdByEmployee, setCreatedByEmployee] = useState(null);

    let [viewInventoryRoomMainDetailsData, setViewInventoryRoomMainDetailsData] = useState([]);
    let [viewInventoryItemMainDetailsData, setViewInventoryItemMainDetailsData] = useState([]);

    let [searchInventoryItem, setSearchInventoryItem] = useState(null);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);
    let [showRoomPics, setShowRoomPics] = useState(false);
    let [showRoomDetails, setShowRoomDetails] = useState(false);
    let [activateRoomButton, setActivateRoomButton] = useState('inline-block');
    let [deactivateRoomButton, setDeactivateRoomButton] = useState('inline-block');

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [searchResults, setSearchResults] = useState([]);

    let [isloading, setLoading] = useState(false);

    let roomItemNameRef = useRef('');
    let itemNameRef = useRef('');

    let slideRef = useRef(null);


    function handleEnterAdminPassword(e) {   setEnterAdminPassword(e.target.value);    }


    function updateDeleteInventoryRoomModal(event) {

        if(event)
        {
            setDeleteInventoryRoomModal(event);
        }
        else
        {

            setDeleteInventoryRoomModal(event);
            setViewRoomDetailsData([]);
            setViewRoomItemsDetailsData([]);

        }
    }


    function updateDeleteInventoryItemModal(event) {

        if(event)
        {
            setDeleteInventoryItemModal(event);
        }
        else
        {
            setDeleteInventoryItemModal(event);
            setViewItemDetailsData([]);
        }

    }

   /*handleSearchInventoryItem(e) {
        setState(() => ({
            searchInventoryItem: e.target.value
        }));

        searchInventoryItemList();
    }*/
    function handleQuantityAddedToRoom(e) {

        setQuantityAddedToRoom(e.target.value);

    }

    function handleQuantityReplenish(e) {

        setQuantityReplenishedStock(e.target.value);

    }

    function handleInventoryAccessCheckbox(checkbox) {


        if(checkbox.checked === true){
            document.getElementById("submit").removeAttribute("disabled");

            setInventoryAccessCheckboxValue("y");

        }
        else{
            document.getElementById("submit").setAttribute("disabled", "disabled");
            setInventoryAccessCheckboxValue("n");
       }
    }


    function updateEnterAdminPasswordDeleteRoomModal(event) {

        setAdminPasswordCreateInventoryRoomModal(event);
        setDeleteInventoryRoomModal(false);
    }



    function updateEnterAdminPasswordDeleteItemModal(event) {

        setAdminPasswordCreateInventoryItemModal(event);
        setDeleteInventoryItemModal(false);
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            seteSlectedFile("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
        }
        else
        {
            seteSlectedFile(event.target.files[0]);

        }


    }



    function deleteRoom()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74399);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', roomID);
        formData.append('xEnterAdminPassword', enterAdminPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74399,
                user: acctID,
                xInventoryRoomID: roomID,
                xEnterAdminPassword: enterAdminPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setDeleteInventoryRoomModal(false);
        setAdminPasswordCreateInventoryRoomModal(false);

    }

    function deleteItem()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74499);
        formData.append('user', acctID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xEnterAdminPassword', enterAdminPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74499,
                user: acctID,
                xInventoryItemID: itemID,
                xEnterAdminPassword: enterAdminPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setDeleteInventoryItemModal(false);
        setAdminPasswordCreateInventoryItemModal(false);

    }


    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        //alert('Inside search room category');
        //alert(searchCategory);
        //alert(searchData);

        /*if(searchCategory === 'name')
        {

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
            Tracker = '74002S_P';

        }*/

        if(searchCategory === 'stock_room_item')
        {

            Tracker = '74302';
        }
        else if(searchCategory === 'delete_stock_room_item')
        {

            Tracker = '74304';

        }
        else if(searchCategory === 'stock_item' || searchCategory === 'delete_stock_item')
        {
            Tracker = '74402';
        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_itemId: cols[0],
                                        db_itemName: cols[1],
                                        db_itemDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });


                            
                                if(searchCategory === 'delete_stock_item')
                                {
                                    setViewItemDetailsData([]);
                    
                                    getItemDetailData(cols[0]);   
                                    document.getElementById('deleteItemGrid').style.display = 'inline-block';
                                }
                            }

                    })
        }

    function stockRoomItems(event)
    {

        /*let formData = new FormData();
        formData.append('Tracker', 74303);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', roomID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryItemAddedToRoom', quantityAddedToRoom);


        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74303,
                user: acctID,
                xInventoryRoomID: roomID,
                xInventoryItemID: event,
                xInventoryItemAddedToRoom: quantityAddedToRoom,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setStockInventoryRoomModal(false);
    }
    function replenishStock()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 72303);
        formData.append('user', acctID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryReplenishStock', quantityReplenishedStock);


        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 72303,
                user: acctID,
                xInventoryItemID: itemID,
                xInventoryReplenishStock: quantityReplenishedStock,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setCreateInventoryRoomModal(false);
    }

    function getDataRoomMain() {
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74301,
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewInventoryRoomMainDetailsData((prevViewInventoryRoomMainDetailsData) => {
                    return prevViewInventoryRoomMainDetailsData.concat({
                        roomID: cols[0],
                        roomType: cols[1],
                        roomPartNum: cols[2],
                        roomPhoneNumber: cols[3],
                        roomCostPerUnit: parseFloat(cols[4]).toFixed(2),
                        roomSalePrice: parseFloat(cols[5]).toFixed(2),
                        roomPic1: cols[6],
                        roomPic2: cols[7],
                        roomPic3: cols[8],
                        roomPic4: cols[9],
                        roomDateCreated: cols[10],
                        roomAddedBy: cols[11],
                        roomIsActivated: cols[12],
                    })
                });

            } 
        })
        
}

function getDataItemMain() {
            
    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: 74401,
            user: acctID,
            sessionID: sessionID,
        }),
    }

    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');


            setViewInventoryItemMainDetailsData((prevViewInventoryItemMainDetailsData) => {
                return prevViewInventoryItemMainDetailsData.concat({
                    itemID: cols[0],
                    itemName: cols[1],
                    vendorPartNum: cols[2],
                    vendorName: cols[3],
                    costPerUnit: parseFloat(cols[4]).toFixed(2),
                    qtyInStock: cols[5],
                    qtyInUse: cols[6],
                    dateReplenished: cols[7],
                    addedBy: cols[8],
                })
            });

        } 

        setLoading(false);
    })
}

function getRoomDetailData(roomID) {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74308,
                user: acctID,
                xInventoryRoomID: roomID,
                sessionID: sessionID,
            }),
        }

        const requestOptions2 = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74310,
                user: acctID,
                xInventoryRoomID: roomID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setRoomID(cols[0]);


                setViewRoomDetailsData((prevViewRoomDetailsData) => {
                    return prevViewRoomDetailsData.concat({
                        roomID: cols[0],
                        roomType: cols[1],
                        roomDescription: cols[2],
                        roomPartNum: cols[3],
                        roomPhoneNumber: cols[4],
                        roomAddress: cols[5],
                        roomCity: cols[6],
                        roomCountry: cols[7],
                        roomCostPerUnit: parseFloat(cols[8]).toFixed(2),
                        roomSalePrice: parseFloat(cols[9]).toFixed(2),
                        roomDateCreated: cols[10],
                    })
                });

            }
            
        })

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions2)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');


                setViewRoomItemsDetailsData((prevViewRoomItemsDetailsData) => {
                    return prevViewRoomItemsDetailsData.concat({
                        itemID: cols[0],
                        itemName: cols[1],
                        QtyAvailable: cols[2],
                        dateAdded: cols[3],
                        addedBy: cols[4],
                    })
                });

            }
            
        })

    }

    function getItemDetailData(itemID) {

        //alert('In getEmployeeDetailData');
        //alert(acctID);
        //alert(employeeID);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74408,
                user: acctID,
                xInventoryItemID: itemID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewItemDetailsData((prevViewItemDetailsData) => {
                    return prevViewItemDetailsData.concat({
                        itemID: cols[0],
                        itemName: cols[1],
                        vendorPartNum: cols[2],
                        vendorName: cols[3],
                        costPerUnit: parseFloat(cols[4]).toFixed(2),
                        qtyInStock: cols[5],
                        qtyInUse: cols[6],
                        dateReplenished: cols[7],
                    })
                });
            } 
        })
    }

function updateShowRoomDetails(event) {

    if(event[0])
    {

        setViewRoomDetailsData([]);
        setViewRoomItemsDetailsData([]);
        setShowRoomDetails(event[0]);

        getRoomDetailData(event[1]);

        if(event[2] === "no")
        {
            setActivateRoomButton('inline-block');
            setDeactivateRoomButton('none');

        }
        else if(event[2] === "yes")
        {

            setActivateRoomButton('none');
            setDeactivateRoomButton('inline-block');   
        }
    }
    else{

        setShowRoomDetails([]);
        setViewRoomDetailsData([]);
        setViewItemDetailsData([]);
    }
}

/*function saveRoomPictures(event) { 

    setRoomPic1(event.target.files[0]);
    setRoomPic2(event.target.files[1]);
    setRoomPic3(event.target.files[2]);
    setRoomPic4(event.target.files[3]);


}*/

function activationStatus(event) {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: 74309,
            user: acctID,
            xInventoryRoomID: roomID,
            xRoomActivationStatus: event,
            sessionID: sessionID,
        }),
    }
    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);
    })

    setShowRoomPics(false);
    setViewRoomDetailsData([]);
    setViewItemDetailsData([]);
}

let timeout;

function handleInput(event) {


    document.getElementById('searchInventoryRoom_StockRoomItemsList').innerHTML = '';


    //document.getElementById('searchInventoryItem_StockItemList').innerHTML = '';

    //alert('Inside handel input 3');
    //alert(event);

    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchList(event), 2000); // Set a new timeout

}

function handleSelection() {

    setViewItemDetailsData([]);

    const selectedItemName = roomItemNameRef.current.value;
    const selectedItem = searchResults.find(result => result.db_itemName === selectedItemName);
  
    if (selectedItem) {
      // Execute your function here using selectedItem.db_itemId
      getItemDetailData(selectedItem.db_itemId);
    }
}


function roomPicsModalHandler(event) {
    setRoomPic1(event[1]);
    setRoomPic2(event[2]);
    setRoomPic3(event[3]);
    setRoomPic4(event[4]);
    setRoomID(event[5]);
    setRoomSalePrice(event[6]);
    setRoomPicsModal(event[0]);

}

function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}

function onSubmitPasswordHandler()
{

    alert(passwordCategory);

    if(passwordCategory == 'delete-r')
    {
        deleteRoom();
    }
    else if(passwordCategory == 'replenish-s')
    {
        alert("Inside Repleshis-s");

        replenishStock();
    }
}

function hotelInventory_roomsHandler()
{
    setInventory_roomsTab_data(true);
    setInventory_itemsTab_data(false);

    setInventory_roomsTab_view('outline');
    setInventory_itemsTab_view('clear');



}
function hotelInventory_itemsHandler()
{
    setInventory_roomsTab_data(false);
    setInventory_itemsTab_data(true);

    setInventory_roomsTab_view('clear');
    setInventory_itemsTab_view('outline');

}

async function handleSlideChange()
{

    let swiper = await slideRef.current?.getSwiper();

    //let activeIndex = swiper?.activeIndex; // Get the current slide index

    let realIndex = swiper?.realIndex; // Get the actual slide index (ignores duplicate slides)

    //alert(realIndex);

    if (realIndex === 0) { // Example: Execute a function when reaching slide 3
        hotelInventory_roomsHandler();
    }
    else if (realIndex === 1) { // Example: Execute a function when reaching slide 3
        hotelInventory_itemsHandler();
    }
  };

  const slideOpts = {
    initialSlide: 0, // Start at the first slide
    speed: 100, // Animation speed (in ms)
    loop: false, // Enable looping
  };



useEffect(() =>  {

    setLoading(true);

        
        getDataRoomMain();   
        getDataItemMain();   

}, [])

//alert('In Management _ Inventory');
//alert(acctID);
//alert(authenticatedMerchent_context.accessRights[0]);
//alert(authenticatedMerchent_context.device);

        return (

            <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol size='6'>
                            <IonButton className='tab_buttons' fill={inventory_roomsTab_view} onClick={() => slideRef.current?.slideTo(0, 100)}> <IonLabel>Rooms</IonLabel> </IonButton>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton className='tab_buttons' fill={inventory_itemsTab_view} onClick={() => slideRef.current?.slideTo(1, 100)}> <IonLabel>Items</IonLabel> </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>
                <IonSlides ref={slideRef} onIonSlideDidChange={handleSlideChange} options={slideOpts}>
                    <IonSlide>
                    <IonContent className='grid_content_slide'>
                        <div id='inventoryRoomOverviewGrid' style={{display: 'inline-block'}}>
                            <IonHeader>
                            <IonToolbar>
                                <IonGrid>
                                    <IonRow >
                                            <IonCol >Room ID</IonCol>
                                            <IonCol >Room Type</IonCol>
                                            {/*<IonCol >Part Number</IonCol>*/}
                                            {/*<IonCol >Phone Number</IonCol>*/}
                                            <IonCol >Cost Price</IonCol>
                                            <IonCol >Sale Price</IonCol>                                        
                                            {/*<IonCol >Date Created</IonCol>*/}
                                            {/*<IonCol >Created By</IonCol>*/}
                                            <IonCol >Action</IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonToolbar>
                            </IonHeader>
                            <IonGrid>

                                {viewInventoryRoomMainDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.roomID}</IonCol>
                                            <IonCol >{detailData.roomType}</IonCol>
                                            {/*<IonCol >{detailData.roomPartNum}</IonCol>detailData*/}
                                            {/*<IonCol >{detailData.roomPhoneNumber}</IonCol>*/}
                                            <IonCol >{detailData.roomCostPerUnit}</IonCol>
                                            <IonCol >{detailData.roomSalePrice}</IonCol>
                                            {/*<IonCol >{detailData.roomDateCreated}</IonCol>*/}
                                            {/*<IonCol >{detailData.roomAddedBy}</IonCol>*/}
                                            <IonCol >
                                                <IonButton  onClick={() => roomPicsModalHandler([true, detailData.roomPic1, detailData.roomPic2, detailData.roomPic3, detailData.roomPic4, detailData.roomID, detailData.roomSalePrice])}> Images </IonButton>
                                                {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton  onClick={() => updateShowRoomDetails([true, detailData.roomID, detailData.roomIsActivated])}> Details </IonButton>}
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            <IonButton onClick={() => setCreateInventoryRoomModal(true)}>Create Room </IonButton>
                            <IonButton onClick={() => updateDeleteInventoryRoomModal(true)}>Delete Room </IonButton>
                        </div>
                        </IonContent>
                    </IonSlide>
                    <IonSlide>
                    <IonContent className='grid_content_slide'>

                        <div id='inventoryItemOverviewGrid' style={{display: 'inline-block'}}>
                                <IonGrid>
                                        <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                {/*<IonCol >Vendor Part Number</IonCol>*/}
                                                {/*<IonCol >Vendor Name</IonCol>*/}
                                                <IonCol >Cost per Unit</IonCol>
                                                <IonCol >Qty InStock</IonCol>
                                                <IonCol >Qty InUse</IonCol>
                                                {/*<IonCol >Date Replenished</IonCol>*/}
                                                {/*<IonCol >Added By</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                        </IonRow>
                                        {viewInventoryItemMainDetailsData.map((detailData) =>   {
                                            return (
                                                <IonRow >
                                                    <IonCol >{detailData.itemID}</IonCol>
                                                    <IonCol >{detailData.itemName}</IonCol>
                                                    {/*<IonCol >{detailData.vendorPartNum}</IonCol>*/}
                                                    {/*<IonCol >{detailData.vendorName}</IonCol>*/}
                                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                                    <IonCol >{detailData.qtyInUse}</IonCol>
                                                    {/*<IonCol >{detailData.dateReplenished}</IonCol>*/}
                                                    {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                    <IonCol >
                                                        <IonButton  > xxx </IonButton>
                                                        <IonButton  > xxx </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            )
                                        }
                                        )}
                                </IonGrid>
                            <IonButton onClick={() => setCreateInventoryItemModal(true)}>Create Item </IonButton>
                            <IonButton onClick={() => setStockInventoryItemModal(true)}>Replenish </IonButton>
                            <IonButton onClick={() => updateDeleteInventoryItemModal(true)}>Delete Item </IonButton>
                        </div>
                        </IonContent>

                    </IonSlide>
                </IonSlides>

                {roomPicsModal == true &&  <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: roomPic1, 
                        roomPic2: roomPic2, 
                        roomPic3: roomPic3, 
                        roomPic4: roomPic4, 
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice
                        }}>
                    </ShowRoomPicsModal>}
                        
                <CreateInventoryRoomModal  openModal={ createInventoryRoomModal } closeModal={() => setCreateInventoryRoomModal(false)}></CreateInventoryRoomModal>
                <CreateInventoryItemModal openModal={ createInventoryItemModal } closeModal={() => setCreateInventoryItemModal(false)}></CreateInventoryItemModal>

                {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                
                </IonContent>

                <IonModal id='showRoomDetails' isOpen={ showRoomDetails}>
                        <IonHeader>
                            <IonGrid >
                                <IonRow>
                                            <IonCol >Room ID</IonCol>
                                            <IonCol >Date Created</IonCol>
                                </IonRow>
                                {viewRoomDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.roomID}</IonCol>
                                            <IonCol >{detailData.roomDateCreated}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                                <IonRow>
                                    <IonCol size='6'>
                                        <h4>Details</h4>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <h4>Stock Items</h4>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonHeader>
                        <IonContent className='occupiedDetails_gridContent'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='6'>
                                    <IonButton id='roomIsDeactivated' style={{display: activateRoomButton}} onClick={() => activationStatus("yes")}> ACTIVATE </IonButton>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonButton id='roomIsActivated' style={{display: deactivateRoomButton}} onClick={() => activationStatus("no")}> DEACTIVATE </IonButton> 
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonSlides>
                                        <IonSlide>
                                        {viewRoomDetailsData.map((detailData) =>   {
                                            return (
                                            <IonGrid >
                                                <IonRow >
                                                    <IonCol >Category</IonCol>
                                                    <IonCol >Value</IonCol>
                                                    <IonCol >Action</IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Type</IonCol>
                                                    <IonCol >{detailData.roomType}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Description</IonCol>
                                                    <IonCol >{detailData.roomDescription}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Part Number</IonCol>
                                                    <IonCol >{detailData.roomPartNum}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Phone Number</IonCol>
                                                    <IonCol >{detailData.roomPhoneNumber}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Address</IonCol>
                                                    <IonCol >{detailData.roomAddress}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >City</IonCol>
                                                    <IonCol >{detailData.roomCity}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Country</IonCol>
                                                    <IonCol >{detailData.roomCountry}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Cost Per Unit</IonCol>
                                                    <IonCol >{detailData.roomCostPerUnit}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Sale Price</IonCol>
                                                    <IonCol >{detailData.roomSalePrice}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            </IonGrid>
                                                    )
                                                }
                                            )}
                                            </IonSlide>
                                            <IonSlide>
                                                <IonGrid >
                                                    <IonRow>
                                                        <IonCol size='12'>
                                                            <IonButton onClick={() => setStockInventoryRoomModal(true)}> Add Item </IonButton>
                                                        </IonCol>
                                                    </IonRow>
                                                    <IonRow >
                                                                <IonCol >Item ID</IonCol>
                                                                <IonCol >Item Name</IonCol>
                                                                <IonCol >Qty Avaialble</IonCol>
                                                                {/*<IonCol >Date Added</IonCol>*/}
                                                                {/*<IonCol >Added by</IonCol>*/}
                                                                <IonCol >Action</IonCol>
                                                    </IonRow>
                                                    {viewRoomItemsDetailsData.map((detailData) =>   {
                                                        return (
                                                            <IonRow >
                                                                <IonCol >{detailData.itemID}</IonCol>
                                                                <IonCol >{detailData.itemName}</IonCol>
                                                                <IonCol >{detailData.QtyAvailable}</IonCol>
                                                                {/*<IonCol >{detailData.dateAdded}</IonCol>*/}
                                                                {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                                <IonCol >
                                                                    <IonButton> update </IonButton>
                                                                </IonCol>
                                                            </IonRow>
                                                        )
                                                    }
                                                    )}
                                                </IonGrid>
                                            </IonSlide>
                                        </IonSlides>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            </IonContent>
                            <IonButton className='button_closeModal_center' onClick={() => setShowRoomDetails(false)}>Cancel </IonButton>
                </IonModal>

                <IonModal id='stockInventoryRoomModal' isOpen={ stockInventoryRoomModal}>
                        <IonHeader>

                            <IonGrid >
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryRoom_StockRoomItems'>Search Inventory Item for Hotel Room:</label>
                                        <input type='text' id='searchInventoryRoom_StockRoomItems' ref={ roomItemNameRef } placeholder='Search Room Item' onInput={() => handleInput(['stock_room_item', roomItemNameRef.current.value])}  onChange={handleSelection} list='searchInventoryRoom_StockRoomItemsList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryRoom_StockRoomItemsList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonLabel>Quantity Added: </IonLabel>
                                            <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityAddedToRoom}></IonInput>                        
                                        </IonItem>  
                                    </IonCol>
                                </IonRow>
                                </IonGrid>

                        </IonHeader>
                                {viewItemDetailsData.map((detailData) =>   {
                                return (
                                <IonGrid >
                                <IonRow >
                                    <IonCol >itemID</IonCol>
                                    <IonCol >{detailData.itemID}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >itemName</IonCol>
                                    <IonCol >{detailData.itemName}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >vendorPartNum</IonCol>
                                    <IonCol >{detailData.vendorPartNum}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >vendorName</IonCol>
                                    <IonCol >{detailData.vendorName}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >Cost Per Unit</IonCol>
                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >qtyInStock</IonCol>
                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >qtyInUse</IonCol>
                                    <IonCol >{detailData.qtyInUse}</IonCol>
                                    <IonCol >
                                        <IonButton > Update </IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol size='4'>Replenish</IonCol>
                                    <IonCol size='4'>
                                        <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityAddedToRoom}></IonInput>                        
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => stockRoomItems(detailData.itemID)}> Confirm </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                                )})}

                    <IonButton className='button_closeModal_center' onClick={() => setStockInventoryRoomModal(false)}>Cancel </IonButton>

                </IonModal>

                <IonModal id='stockInventoryItemModal' isOpen={ stockInventoryItemModal}>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryItem_StockItem'>Search Inventory Item:</label>
                                        <input type='text' id='searchInventoryItem_StockItem' ref={ itemNameRef } placeholder='Search Inventory Items To Stock' onInput={() => handleInput(['stock_item', itemNameRef.current.value])} list='searchInventoryItem_StockItemList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryItem_StockItemList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonLabel>Quantity Added: </IonLabel>
                                            <IonInput type='number' placeholder='Enter Qty' onIonChange={handleQuantityReplenish}></IonInput>                        
                                        </IonItem>    
                                    </IonCol>
                                </IonRow>
                            </IonGrid>                    
                        </IonSlide>
                    </IonSlides>

                    <IonButton className='modal_footer_button_left' onClick={() => setShowPasswordModalHandler([true, 'replenish-s'])}> Confirm Replenish Stock </IonButton> 
                    <IonButton className='modal_footer_button_right' onClick={() => setStockInventoryItemModal(false)}>Cancel </IonButton>

                </IonModal>

                <IonModal id='deleteInventoryRoomModal' isOpen={ deleteInventoryRoomModal}>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryRoom_DeleteRoom'>Search Rooms For Deletion </label>
                                        <input type='text' id='searchInventoryRoom_DeleteRoom' ref={ itemNameRef } placeholder='Search Inventory Room to Delete Room' onInput={() => handleInput(['delete_stock_room_item', roomItemNameRef.current.value])} list='searchInventoryRoom_DeleteRoomList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryRoom_DeleteRoomList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                            <div id='deleteRoomGrid' style={{display: 'none'}}>
                            <IonGrid >
                            <IonRow >
                                        <IonCol >Room ID</IonCol>
                                        <IonCol >Room Type</IonCol>
                                        <IonCol >Part Number</IonCol>
                                        <IonCol >Phone Number</IonCol>
                                        <IonCol >Room Cost Per Unit</IonCol>
                                        <IonCol >Room Sale Price</IonCol>
                                        <IonCol >Date Created</IonCol>
                                </IonRow>
                                {viewRoomDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.roomID}</IonCol>
                                            <IonCol >{detailData.roomType}</IonCol>
                                            <IonCol >{detailData.roomPartNum}</IonCol>
                                            <IonCol >{detailData.roomPhoneNumber}</IonCol>
                                            <IonCol >{detailData.roomCostPerUnit}</IonCol>
                                            <IonCol >{detailData.roomSalePrice}</IonCol>
                                            <IonCol >{detailData.roomDateCreated}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            </div>

                            <IonButton onClick={() => setShowPasswordModalHandler([true, 'delete-r'])}> Confirm Room Deletion </IonButton>                         
                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => updateDeleteInventoryRoomModal(false)}>Cancel </IonButton>
                </IonModal>


                <IonModal id='deleteInventoryItemModal' isOpen={ deleteInventoryItemModal}>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryItem_deleteItem'>Search Rooms For Deletion </label>
                                        <input type='text' id='searchInventoryRoom_DeleteRoom' ref={ itemNameRef } placeholder='Search Inventory Items To Delete' onInput={() => handleInput(['delete_stock_item', itemNameRef.current.value])} list='searchInventoryItem_deleteItemList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryItem_deleteItemList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                            <div id='deleteItemGrid' style={{display: 'none'}}>
                            <IonGrid >
                            <IonRow >
                                        <IonCol >Item ID</IonCol>
                                        <IonCol >Item Name</IonCol>
                                        <IonCol >Vendor Part Number</IonCol>
                                        <IonCol >Vendor Name</IonCol>
                                        <IonCol >Cost per Unit</IonCol>
                                        <IonCol >Qty InStock</IonCol>
                                        <IonCol >Qty InUse</IonCol>
                                        <IonCol >Date Replenished</IonCol>
                                </IonRow>
                                {viewItemDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.itemID}</IonCol>
                                            <IonCol >{detailData.itemName}</IonCol>
                                            <IonCol >{detailData.vendorPartNum}</IonCol>
                                            <IonCol >{detailData.vendorName}</IonCol>
                                            <IonCol >{detailData.costPerUnit}</IonCol>
                                            <IonCol >{detailData.qtyInStock}</IonCol>
                                            <IonCol >{detailData.qtyInUse}</IonCol>
                                            <IonCol >{detailData.dateReplenished}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            </div>

                            <IonButton onClick={() => updateEnterAdminPasswordDeleteItemModal(true)}> Confirm Item Deletion </IonButton>                         
                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => updateDeleteInventoryItemModal(false)}>Cancel </IonButton>
                </IonModal>

                <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>



                <IonModal id='enterAdminPasswordDeleteItem' isOpen={ adminPasswordDeleteItemModal}>
                    <IonSlides>
                        <IonSlide>
                            <IonItem> 
                            <h1>Enter Password</h1>
                                <label for='adminPasswordDeleteItem'>Invoice</label>
                                 <IonInput type='text' id='adminPasswordDeleteItem' onIonChange={(e) => handleEnterAdminPassword(e)}></IonInput>
                            </IonItem>
                            <IonButton onClick={() => deleteItem()}> Delete Item </IonButton>                         
                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => updateEnterAdminPasswordDeleteItemModal(false)}>Cancel </IonButton>
                </IonModal>
            </React.Fragment>
        )
    }   